import { Component } from 'react';
import EditorFaq from "../components/EditorFaq";
import GameData from "../mobx/GameData";
import { NamEditor } from "../components/nes/NamEditor";
import { observe } from "mobx";
import { Accordion, Container, Row, Col } from "react-bootstrap";
import GraphicsPatcher from "../components/services/GraphicsPatcher";

export default class CreditsPage extends Component {

    gameDataCleanup = null;
    protectedRegions = null;

    componentDidMount() {
        this.gameDataCleanup = observe(GameData, () => { 
            this.forceUpdate()
        });
        this.buildProtectedRegions();
        this.forceUpdate();
    }

    componentWillUnmount() {
        if (this.gameDataCleanup) {
            this.gameDataCleanup();
        }
    }

    buildProtectedRegions() {
        const leftX = GraphicsPatcher.creditsLeftX;
        const rightX = GraphicsPatcher.creditsRightX;
        let topY = null;
        let bottomY = null;
        if (GameData.currentGame.useBuiltInGraphics) {
            topY = GraphicsPatcher.creditsTopYArt; 
            bottomY = GraphicsPatcher.creditsBottomYArt;
        }
        if (GameData.currentGame.usingBuiltInMusic) {
            topY = topY || GraphicsPatcher.creditsTopYMusic; 
            bottomY = GraphicsPatcher.creditsBottomYMusic;
        }

        if (topY && bottomY) {
            this.protectedRegions = [{x1: leftX, y1: topY, x2: rightX, y2: bottomY}];
        }

    }

    render() {
        return (
            <Container className="credits-page">
                <Row>
                    <Col>

                        <h1>Credits Screen</h1>
                        <p className="mt-3">
                            This screen will be shown once your game is beaten. It should
                            be used to credit everyone involved in creating your game. Note that if you are using built-in art, it cannot be 
                            removed from the page below.
                        </p>
                        
                        <div className="mt-3">
                            <NamEditor 
                                fieldName="creditsScreenData" 
                                protectedRegions={this.protectedRegions}
                            />
                        </div>
                        <EditorFaq>
                        <Accordion.Item eventKey="custom-1">
                                <Accordion.Header>Why can't I edit the section with music and graphics?</Accordion.Header>
                                <Accordion.Body>
                                    <p>
                                        If your game uses any of the assets provided with the tool, we require you to credit the original authors. 
                                        We enforce this by including a section on your credits page with that data, which you cannot edit. 
                                    </p>
                                    <p>
                                        If you create your own art and/or music, these sections will unlock, so that you can properly credit your
                                        musicians and artists.
                                    </p>
                                </Accordion.Body>
                            </Accordion.Item>
                        </EditorFaq>
                    </Col>
                </Row>
            </Container>
        );
    }
}